import { render } from "./_PageHeading.vue?vue&type=template&id=66e41022&scoped=true&lang=en"
import script from "./_PageHeading.vue?vue&type=script&lang=js"
export * from "./_PageHeading.vue?vue&type=script&lang=js"

import "./_PageHeading.vue?vue&type=style&index=0&id=66e41022&scoped=true&lang=scss"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e41022"]])

export default __exports__